<template>
  <vs-sidebar click-not-close parent="#correction" :hidden-background="true" class="correction-view-sidebar full-vs-sidebar items-no-padding" v-model="isSidebarActive" position-right>
    <div class="px-0 sm:pb-6 h-full">
      <div class="flex flex-wrap items-center correction-header justify-between md:px-8 px-6 sm:pb-2 sm:pt-2 d-theme-dark-bg">
        <div class="flex items-center">
          <div class="mr-4">
            <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer" svg-classes="w-6 h-6"></feather-icon>
          </div>
          <div class="mr-1">
            <vs-avatar :src="student.image" size="42px" @click="viewProfile(student.user_id)"></vs-avatar>
          </div>
          <div class="w-full flex items-center">
            <div class="flex flex-col truncate">
              <h5 class="font-bold text-primary cursor-pointer" @click="viewProfile(student.user_id)">{{student.full_name}}</h5>
              <span class="truncate">{{student.id}}</span>
            </div>
          </div>
        </div>
      </div>
      <VuePerfectScrollbar v-if="Object.keys(student.answers).length > 0"
                           class="scroll-content-area md:px-8 md:pb-8 pt-4 px-6 pb-6"
                           :settings="{ wheelPropagation: true }" :key="$vs.rtl">
        <div v-for="(question, index) in questions" :key="question.id" class="w-full mb-base">
          <template v-if="student.answers[question.id]">
            <quiz-question-item
              :number="index"
              :question="question"
              :answer="student.answers[question.id]"/>
          </template>
          <template v-else>
            <vx-card :title="`السؤال ${index + 1}`" no-shadow card-border>
              <vs-alert active="true" color="danger">لم يقم الطالب بالإجابة عن هدا السؤال</vs-alert>
            </vx-card>
          </template>
        </div>
        <vx-card no-shadow card-border>
          <div class="flex">
            <div class="text-center lg:w-1/5 w-full">
              <span class="block">مجموع الاسئلة المجاب عليها</span>
              <span class="text-2xl font-bold">{{Object.keys(student.answers).length}}/{{questions.length}}</span>
            </div>
            <div class="text-center lg:w-1/5 w-full">
              <span class="block">مجموع الدرجات</span>
              <span class="text-2xl font-bold">{{marks}}</span>
            </div>
            <div class="text-center lg:w-1/5 w-full">
              <span class="block">عدد الاسئلة المصححة</span>
              <span class="text-2xl font-bold">{{calcTotalCorrectedQuestion}}/{{questions.length}}</span>
            </div>
          </div>
        </vx-card>
        <vs-button class="bg-primary-gradient mt-5 sm:w-64 w-full" @click="correct">تصحيح</vs-button>
      </VuePerfectScrollbar>
      <template v-else>
        <div class="flex flex-col items-center mt-24">
          <feather-icon icon="UserXIcon" class="mb-4 p-8 shadow-md rounded-full" svgClasses="w-16 h-16" />
          <h4 class="py-2 px-4 shadow-md rounded-full">لم يقم الطالب بالإختبار</h4>
        </div>
      </template>
    </div>
  </vs-sidebar>
</template>

<script>
    import quizzesAPI from '@/api/quizzesAPI'
    import QuizQuestionItem from '@/views/course/quizzes/QuizQuestionItem'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        name: 'QuizCorrectionView',
        components: { QuizQuestionItem, VuePerfectScrollbar },
        props: {
            student: {
                type: Object,
                required: true
            },
            questions: {
                type: Array,
                required: true
            },
            isSidebarActive: {
                type: Boolean,
                required: true
            },
        },
        watch: {
            isSidebarActive(value) {
                if (!value) this.$emit('closeSidebar')
            },
        },
        computed: {
            calcStudentMarks(){
                let studentMarks = Object.values(this.student.answers).reduce((total, answer) => total + parseFloat(answer.mark), 0)
                return isNaN(studentMarks) ? 0 : studentMarks
            },
            calcTotalMarks(){
                return this.questions.reduce((total, question) => total + question.mark, 0)
            },
            marks() {
                return `${this.calcStudentMarks}/${this.calcTotalMarks}`
            },
            calcTotalCorrectedQuestion(){
                return Object.values(this.student.answers).filter(answer => (answer.mark !== null)).length
            }
        },
        methods: {
            correct(){
                let marks = []
                Object.keys(this.student.answers).forEach(question_id => {
                    let mark = this.student.answers[question_id].mark || 0
                    let teacher_comment = this.student.answers[question_id].teacher_comment || null
                    marks.push({question_id, mark, teacher_comment})
                })
                let data = {quiz_group: this.student.groupNum, marks: marks}
                let quiz_id = this.$route.params.quiz_id
                quizzesAPI.correctQuiz(quiz_id, this.student.id, data)
                    .then(response => {
                      this.$notifySuccess(response.successMessage)
                      this.$emit('correct', this.student)
                      this.$emit('closeSidebar')
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
            },
        }
    }
</script>
